import ReactDOM from 'react-dom';

// Floating panel anchored to a cursor/touch point `{ x, y }`, offset from it
// and clamped so it never runs off-screen. Used two ways:
//  - hover (desktop mouse): transient, pointer-events: none, closes on mouseleave,
//    and follows the cursor while it moves over the row.
//  - tap (touch, `pinned`): stays open, adds a backdrop + close button, closes on
//    tapping the backdrop / close button / the same row again.
const HoverPopover = ({ point, width = 280, pinned = false, onClose, children }) => {
  if (!point) return null;

  const margin = 16;
  const edge = 8;
  const viewportW = window.innerWidth;
  const viewportH = window.innerHeight;
  const cardWidth = Math.min(width, viewportW - edge * 2);
  const estHeight = 280;

  let left = point.x + margin;
  if (left + cardWidth > viewportW - edge) left = point.x - cardWidth - margin;
  if (left < edge) left = edge;

  let top = point.y + margin;
  if (top + estHeight > viewportH - edge) top = point.y - estHeight - margin;
  if (top < edge) top = edge;

  return ReactDOM.createPortal(
    <>
      {pinned && <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 3999 }} />}
      <div style={{ position: 'fixed', top, left, width: cardWidth, zIndex: 4000, pointerEvents: pinned ? 'auto' : 'none' }}>
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: 12,
            boxShadow: 'var(--sh-md)',
            padding: 14,
            position: 'relative',
            animation: 'fadeIn .12s ease-out',
          }}
        >
          {pinned && (
            <button
              onClick={onClose}
              aria-label="Close"
              style={{
                position: 'absolute', top: 8, right: 8, width: 24, height: 24, borderRadius: '50%',
                border: 'none', background: 'var(--surface-3)', color: 'var(--text-2)', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, lineHeight: 1, padding: 0,
              }}
            >
              ×
            </button>
          )}
          {children}
        </div>
      </div>
    </>,
    document.body
  );
};

export default HoverPopover;
